import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PayrollService } from "./PayrollServices";
import { toast } from "react-toastify";
import { successAlert } from "../Global/GlobalSlice";

export const GetEmployeeRenumeration = createAsyncThunk(
  "payroll/GetEmployeeRenumeration",
  async (year, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PayrollService.PayService().GetEmployeeRenumeration({ year });

      // console.log("API response:", response);

      if (response) {
        return response;
      } else {
        return rejectWithValue({ statusMessage: "No data found" });
      }
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetPayrollDashboard = createAsyncThunk(
  "payroll/GetPayrollDashboard",
  async (params, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PayrollService.PayService().GetPayrollDashboard(params);

      // console.log("API response:", response);

      if (response) {
        return response;
      } else {
        return rejectWithValue({ statusMessage: "No data found" });
      }
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetRenumerationBreakdown = createAsyncThunk(
  "payroll/GetRenumerationBreakdown",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PayrollService.PayService().GetRenumerationBreakdown(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const SendPaymentToFinance = createAsyncThunk(
  "payroll/SendPaymentToFinance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log(payload)
      const response = await PayrollService.PayService().SendPaymentToFinance(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const declinePaymentToFinance = createAsyncThunk(
  "payroll/declinePaymentToFinance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PayrollService.PayService().declinePaymentToFinance(payload);
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const SendPaymentToFinancePaymentRequisition = createAsyncThunk(
  "payroll/SendPaymentToFinancePaymentRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await PayrollService.PayService().SendPaymentToFinancePaymentRequisition(
        payload
      );
      // console.log('payroll Data', response?.data)
      return response?.data;
      // console.log(response?.data);
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  isLoading: false,
  isSuccessful: false,
  get_employeerenumeration: null,
  error: null,
};

export const PayrollSlice = createSlice({
  name: "payroll",
  initialState,
  reducers: {}, // You can add reducers if needed
  extraReducers: (builder) => {
    builder.addCase(GetPayrollDashboard.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
        isSuccessful: false,
        error: null,
      };
    });

    builder.addCase(GetPayrollDashboard.fulfilled, (state, { payload }) => {
      console.log("API response payload:", payload);
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_employeerenumeration: payload?.responseObject || null,
        error: null,
      };
    });

    builder.addCase(GetPayrollDashboard.rejected, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: payload || { statusMessage: "An error occurred" },
      };
    });

    builder.addCase(GetEmployeeRenumeration.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
        isSuccessful: false,
        error: null,
      };
    });

    builder.addCase(GetEmployeeRenumeration.fulfilled, (state, { payload }) => {
      console.log("API response payload:", payload);
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        get_employeerenumeration: payload?.responseObject || null,
        error: null,
      };
    });

    builder.addCase(GetEmployeeRenumeration.rejected, (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: payload || { statusMessage: "An error occurred" },
      };
    });

    // GetPayrollDashboard

    builder.addCase(GetRenumerationBreakdown.pending, (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(
      GetRenumerationBreakdown.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          all_renumerationbreakdown: payload,
        };
      }
    );
    builder.addCase(GetRenumerationBreakdown.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    });
  },
});

// Export the response selector
// export const response = (state) => state.payroll.get_employeerenumeration;

export default PayrollSlice.reducer;
